module.exports = __webpack_public_path__ + "eb106e17ec98b503a9ea1b5a452a44e6.svg";